<template>
    <section class="flex-column">
        <!-- <el-input autocomplete="off" v-model="tiersCode"></el-input> -->
        <el-form-item prop="tiers" :label="$t.__('common.labels.third_account')">
            <el-autocomplete
                v-model="tiersCode"
                :fetch-suggestions="tiersCodeSuggestions"
            ></el-autocomplete>
        </el-form-item>
        <el-form-item
            v-if="$store.state.individual.details.type === 'supplier'"
            prop="purchase"
            :label="
                $t.__('thirds.thirdscomponents.FormFieldsIndividualsAccountability.charge_account')
            "
        >
            <el-autocomplete
                v-model="purchaseCode"
                :fetch-suggestions="purchaseCodeSuggestions"
            ></el-autocomplete>
        </el-form-item>
        <el-form-item
            prop="auxiliary"
            :label="
                $t.__(
                    'thirds.thirdscomponents.FormFieldsIndividualsAccountability.auxiliary_account_code',
                )
            "
        >
            <el-input autocomplete="off" v-model="auxiliaryCode"></el-input>
        </el-form-item>
    </section>
</template>

<script>
export default {
    name: 'FormFieldsIndividualsAccountability',
    props: {
        storeModule: {
            type: String,
            default: () => 'store-module-name',
        },
        error: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    computed: {
        auxiliaryCode: {
            get() {
                return this.$store.getters[`${this.storeModule}/getAuxiliaryCode`];
            },
            set(value) {
                this.$store.commit(`${this.storeModule}/setAuxiliaryCode`, value);
            },
        },
        tiersCode: {
            get() {
                return this.$store.getters[`${this.storeModule}/getTiersCode`];
            },
            set(value) {
                this.$store.commit(`${this.storeModule}/setTiersCode`, value);
            },
        },
        purchaseCode: {
            get() {
                return this.$store.getters[`${this.storeModule}/getPurchaseCode`];
            },
            set(value) {
                this.$store.commit(`${this.storeModule}/setPurchaseCode`, value);
            },
        },
    },
    methods: {
        tiersCodeSuggestions(queryString, cb) {
            const suggestions = this.$store.getters[`${this.storeModule}/getTiersCodeList`];
            const results = queryString
                ? suggestions.filter(this.createFilter(queryString))
                : suggestions;
            cb(results);
        },
        purchaseCodeSuggestions(queryString, cb) {
            const suggestions = this.$store.getters[`${this.storeModule}/getPurchaseCodeList`];
            const results = queryString
                ? suggestions.filter(this.createFilter(queryString))
                : suggestions;
            cb(results);
        },
        createFilter(queryString) {
            return (query) => {
                return query.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.el-autocomplete {
    width: 100% !important;
}
</style>
